import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUser } from "../../helpers/user";
import { getPontosMonitoriaGeral } from "./services";

const initialState: any = {
  status: "",
  data: null,
};

export const actionGetPontosMonitoriaGeral: any = createAsyncThunk<any, string>(
  "ACTION_GET_PONTOS_MONITORIA_GERAL",
  async (apiKey, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
    } = getState();
    const user = apiKey ? getUser() : null;

    return getPontosMonitoriaGeral(
      lojaSelected,
      String(user?.usuario?.idCliente || 1),
      apiKey,
    );
  },
);

const sliceGetPontosMonitoriaGeral = createSlice({
  name: "GET_PONTOS_GERAL",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetPontosMonitoriaGeral.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetPontosMonitoriaGeral.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    },
    [actionGetPontosMonitoriaGeral.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetPontosMonitoriaGeral.reducer;
